import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Google Analytics Component
 * Dynamically loads Google Analytics script based on admin settings
 */
const GoogleAnalytics = () => {
  const [gaId, setGaId] = useState(null);

  useEffect(() => {
    const fetchGaId = async () => {
      try {
        const response = await fetch(`${API}/api/public/payment-settings`);
        if (response.ok) {
          const data = await response.json();
          if (data.google_analytics_id) {
            setGaId(data.google_analytics_id);
          }
        }
      } catch (error) {
        console.error('Error fetching GA settings:', error);
      }
    };
    fetchGaId();
  }, []);

  useEffect(() => {
    if (!gaId) return;

    // Check if script already exists
    if (document.querySelector(`script[src*="googletagmanager.com/gtag"]`)) {
      return;
    }

    // Load Google Analytics script
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    script.async = true;
    document.head.appendChild(script);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId);

    console.log('Google Analytics initialized:', gaId);

    return () => {
      // Cleanup if needed
    };
  }, [gaId]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
